import { createContext, useContext, ReactNode } from "react";

export type EnhancedCartAnalyticsSource = "puck";

export interface EnhancedCartSummaryAnalyticsContextValue {
  cartVersion: "enhanced";
  source?: EnhancedCartAnalyticsSource;
}

const EnhancedCartSummaryAnalyticsContext =
  createContext<EnhancedCartSummaryAnalyticsContextValue | null>(null);

export function useEnhancedCartSummaryAnalytics(): EnhancedCartSummaryAnalyticsContextValue | null {
  return useContext(EnhancedCartSummaryAnalyticsContext);
}

export function EnhancedCartSummaryAnalyticsProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: EnhancedCartSummaryAnalyticsContextValue;
}): JSX.Element {
  return (
    <EnhancedCartSummaryAnalyticsContext.Provider value={value}>
      {children}
    </EnhancedCartSummaryAnalyticsContext.Provider>
  );
}
